<template>
    <component :is="wrapperComponentType" :id="id" :class="{ 'patient-panel-block': true, 'description-mobile-visible': descriptionMobileVisible }" @click="click" v-if="_visible">
			<div class="neu-card mx-auto px-4 px-xl-4" :style="`backgroundColor: ${_backgroundColor}`">
					<slot name="absolute-items"></slot>
					<div class="m-auto">
						<base-icon v-if="!iconSlot" :src="img" alt="" :height="iconSize" :width="iconSize" :color="_textAndIconColor" class="d-block mb-3"></base-icon>
						<slot name="icon" v-else></slot>
						<p :class="{ 'neu-card-title': true, 'd-block': true, 'with-info': !!description }" :style="`color: ${_textAndIconColor}`" v-html="title"></p>
						<slot></slot>
						<span v-if="enabled">
							<span v-if="description" class="d-none d-xl-block neu-card-description">{{ description }}</span>
							<p v-if="description && toggleableMobileDescription" class="d-xl-none info-btn" @click="(event) => { event.stopPropagation(); descriptionMobileVisible = !descriptionMobileVisible }">
									<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/ICN_OUT_INFORMACION.svg" :color="_textAndIconColor"></base-icon>
							</p>
							<span v-if="descriptionMobileVisible" class="d-block mt-2" :style="`color: ${GRAY_COLOUR}`">
									{{ description }}<br>
									<base-button class="mt-3" @click="click" v-if="actionable && !hideArrowMobileButton"><arrow-icon color="white"/></base-button>
							</span>
							<b-badge :class="{ 'blink': blinkSoonLabelActive }" class="mt-3 soon-label" v-if="soonLabel" variant="primary">{{ $t('soon-label') }}</b-badge>
						</span>
						<span v-else>
							<b-badge class="mt-3" variant="info">{{ notEnabledText }}</b-badge>
						</span>
						<slot name="footer" v-if="enabled"></slot>
					</div>
			</div>
    </component>
</template>

<script>
/* import { OPENSALUD_PRIME_SERVICE } from '@/constants/patientServices' */
import {
	BLUE_COLOUR,
	WHITE_COLOUR,
	GRAY_COLOUR
} from '@/constants/colours'
import ArrowIcon from '@/components/base/icons/ArrowIcon.vue'
import {
	BBadge
} from 'bootstrap-vue'

export default {
	name: 'PatientPanelServiceBlock',
	components: {
		ArrowIcon,
		BBadge
	},
	props: {
		id: {
			type: String,
			required: true
		},
		img: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		description: {
			type: String
		},
		action: {
			type: Function,
			required: false,
			default: () => {}
		},
		clickOnceEnabled: {
			type: Boolean,
			required: false,
			default: true
		},
		visible: {
			type: Boolean,
			required: false,
			default: null
		},
		active: {
			type: Boolean,
			required: false,
			default: null
		},
		only360Users: {
			type: Boolean,
			required: false,
			default: false
		},
		enabled: {
			type: Boolean,
			required: false,
			default () {
				return !this.only360Users || !!this.$store.getters['session/userHasCompanies']
			}
		},
		notEnabledText: {
			type: String,
			required: false,
			default () {
				return this.only360Users ? this.$t('patient-panel.only-subscriptors') : this.$t('patient-panel.not-available')
			}
		},
		iconSize: {
			type: String,
			required: false,
			default () {
				return !this.$uiHelpers.isXlDevice ? '30' : '40'
			}
		},
		soonLabel: {
			type: Boolean,
			required: false,
			default: false
		},
		backgroundImg: {
			type: String,
			required: false
		},
		isColumnType: {
			type: Boolean,
			required: false,
			default: true
		},
		backgroundColor: {
			type: String,
			required: false,
			default: WHITE_COLOUR
		},
		textAndIconColor: {
			type: String,
			required: false,
			default () {
				return this.enabled ? BLUE_COLOUR : GRAY_COLOUR
			}
		},
		path: {
			type: String,
			required: false
		},
		actionable: {
			type: Boolean,
			required: false,
			default: true
		},
		toggleableMobileDescription: {
			type: Boolean,
			required: false,
			default: true
		},
		hideArrowMobileButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	mounted () {
		this.descriptionMobileVisible = !this.$uiHelpers.isDesktop && !this.toggleableMobileDescription
		if (this.backgroundImg) {
			// Add css rule to .patient-panel-block > .neu-card with the background image
			const style = document.createElement('style')
			// Radial gradient
			const radialGradient = `radial-gradient(circle, ${WHITE_COLOUR}, #ffffff57)`
			/* style.innerHTML = `#${this.id} .neu-card { background-image: linear-gradient(0deg, rgb(255 255 255 / 68%), rgb(255 255 255 / 60%)), url(${this.backgroundImg}); background-size: cover; }` */
			style.innerHTML = `#${this.id} .neu-card { background-image: ${radialGradient}, url(${this.backgroundImg}); background-size: cover; }`
			document.head.appendChild(style)
		}
	},
	data () {
		return {
			BLUE_COLOUR,
			GRAY_COLOUR,
			descriptionMobileVisible: false,
			blinkSoonLabelActive: false,
			clicksAmount: 0
		}
	},
	computed: {
		_visible () {
			// Opensalud Prime service is visible only if it is enabled
			return (this.visible || (this.active))
		},
		wrapperComponentType () {
			return !this.isColumnType ? 'div' : 'b-col'
		},
		clickDisabled () {
			return this.clickOnceEnabled && this.clicksAmount > 0
		},
		_textAndIconColor () {
			return this.enabled ? this.textAndIconColor : GRAY_COLOUR
		},
		_backgroundColor () {
			return this.enabled ? this.backgroundColor : WHITE_COLOUR
		},
		iconSlot () {
			return this.$slots.icon
		}
	},
	methods: {
		highlightSoonLabel () {
			this.blinkSoonLabelActive = true
			setTimeout(() => {
				this.blinkSoonLabelActive = false
			}, 4000)
		},
		click () {
			if (!this.actionable) return
			if (this.only360Users && !this.$store.getters['session/userHasCompanies']) {
				this.$store.dispatch('showOnlySubscriptorsDialog')
				return
			}
			this.clickAmount++
			if (this.soonLabel) {
				this.highlightSoonLabel()
			} else if (!this.clickDisabled) {
				if (this.path) {
					this.$router.push(this.path)
				} else {
					this.action()
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/360.scss";
	
	.patient-panel-block {
		@include desktop {
			margin-bottom: 2rem;
		}
	}

  .neu-card {
		min-height: contents;

    @include media(desktop-sm, tablets, mobile) {
				margin-bottom: 2rem;

				> * {
					text-align: center;
				}

				.info-btn {
					position: absolute;
					right: 20px;
					top: 10px;
				}

        &:not(.description-mobile-visible) {
            min-height: 65px;
        }
        &.description-mobile-visible {
            min-height: 200px;
        }
    }
	@media only screen and (min-width: 1024px) and (max-width: 1366px) and (min-height: 600px) and (max-height: 1024px) {
		margin-bottom: 2rem;

				> * {
					text-align: center;
				}

				.info-btn {
					position: absolute;
					right: 0px;
					top: 0px;
				}

				
				&.description-mobile-visible {
				min-height: 200px;
				}
	}

		> div {
			min-width: 60%;
		}
  }

  .neu-card-title {
    vertical-align: middle;
		@include desktop {
			margin-top: 1rem !important;
			margin-bottom: 0rem !important;
			font-size: 1.25rem;
		}
  }

	.neu-card-description {
		@include desktop {
			margin-top: 1rem !important;
		}
	}

  p {
    @include media(mobile, tablets) {
        margin: {
            top: 0 !important;
            bottom: 0 !important;
        }
    }
	}
</style>


// WEBPACK FOOTER //
// src/components/PatientPanelServiceBlock.vue